import app from 'firebase/app';
import { executeSearchQuery } from './firestoreUtils';

const getReviewCollection = () => app.firestore().collection('transactions');

export const newTransaction = dto => {
    return new Promise(function (resolve, reject) {
        const docRef = getReviewCollection().doc();
        dto.uid = docRef.id;
        docRef.set({ ...dto });
        if (docRef && docRef.id) {
            resolve(docRef.id);
        } else {
            reject('Object not created');
        }
    });
};
